import { render, staticRenderFns } from "./FloorSwitcher.vue?vue&type=template&id=072a83ee&scoped=true&"
import script from "./FloorSwitcher.vue?vue&type=script&lang=js&"
export * from "./FloorSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./FloorSwitcher.scss?vue&type=style&index=0&id=072a83ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a83ee",
  null
  
)

export default component.exports